<template>
  <div class="plate-list-page">
    <div class="plate-list-page__sticky" :style="stickyStyle">
      <div v-if="showBanner" class="bannerWrap">
        <swiperComponents :adData="adData"></swiperComponents>
        <!-- <div class="bannerClose" @click="handleCloseBanner">
          <van-icon name="cross" />
        </div> -->
      </div>
      <div v-if="searchInfo" class="titleRow">
        <div class="titleRow__main">
          <img class="plateIcon" :src="require('../../assets/img/platelistIcon.png')" alt="" />
          <span v-if="!searchInfo.name" class="custom-title">全部板块</span>
          <template v-else>
            <span @click="back" class="titleRow__link">{{ searchInfo.parentsName }}</span
            ><span class="titleRow__sep">-></span><span>{{ searchInfo.name }}</span>
          </template>
          <!-- <van-tag v-else style="margin-right:5px;font-weight: 600;" type="danger">{{
          searchInfo.name
        }}</van-tag> -->
        </div>
        <span v-if="searchInfo.onlineCount" class="custom-title titleRow__meta"
          >当前在线{{ searchInfo.onlineCount }}人</span
        >
      </div>
      <div class="searchBox">
        <form action="/">
          <van-search
            show-action
            v-model="searchContent"
            placeholder="请输入搜索关键词"
            @search="onSearch"
            @clear="onSearch"
          >
            <template #action>
              <div class="searchbtn" @click.stop="onSearch">搜索</div>
            </template>
          </van-search>
        </form>

        <div class="searchBox__toolbar">
          <van-radio-group
            @change="toggle"
            class="searchTypeClass"
            v-model="searchType"
            direction="horizontal"
          >
            <van-radio class="radiaodiy" name="title">主题</van-radio>
            <van-radio class="radiaodiy" name="author">作者</van-radio>
            <van-radio class="radiaodiy" name="content">内容</van-radio>
          </van-radio-group>
          <van-checkbox
            @click="listsortTime"
            v-model="sortTime"
            class="searchTypeClass"
            shape="square"
            >按时间</van-checkbox
          >
          <div @click="handleFilterClick" class="searchBox__type" ref="filterTrigger">
            {{ getTypeName() }}
            <van-icon :name="isPcView && pcDropdownShow ? 'arrow-up' : 'arrow'" />
            <!-- PC端下拉菜单 -->
            <div v-if="isPcView && pcDropdownShow" class="pc-filter-dropdown" @click.stop>
              <div
                class="pc-filter-dropdown__item"
                v-for="(item, index) in checkboxGroup"
                :key="index"
                @click.stop="pcDropdownToggle(item.type)"
              >
                <span class="pc-filter-dropdown__check">{{
                  types.includes(item.type) ? '✓' : ''
                }}</span>
                <span>{{ item.title }}</span>
              </div>
              <div class="pc-filter-dropdown__footer">
                <button class="pc-filter-dropdown__btn" @click.stop="selType">确认</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup
      v-if="!isPcView"
      class="plate-list-filter-popup"
      position="center"
      :style="{
        fontSize: '25px',
        width: '80%',
        maxWidth: '80%',
      }"
      v-model="checkboxShow"
    >
      <div style="padding: 5px; ">
        <van-checkbox-group v-model="types" ref="checkboxGroup">
          <!-- <van-checkbox style="margin-bottom: 5px;" shape="square" :name="4">只看成交</van-checkbox>
          <van-checkbox style="margin-bottom: 5px;" shape="square" :name="1">只看求购</van-checkbox>
          <van-checkbox style="margin-bottom: 5px;" shape="square" :name="2">只看出售</van-checkbox> -->

          <van-cell-group>
            <van-cell
              size="large"
              v-for="(item, index) in checkboxGroup"
              clickable
              :key="index"
              :title="item.title"
              @click="checkboxGroupToggle(index)"
            >
              <template #right-icon>
                <van-checkbox shape="square" :name="item.type" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <van-button type="info" @click="selType" block size="small">确认</van-button>
      </div>
    </van-popup>
    <!-- 只有 联体钞/纪念钞 Y003002
    普通纪念币  Y003007
    评级币/评级钞 Y003016 显示 -->
    <div class="downLoadApp">
      公众号：一尘盯盘助手
      <!-- <img class="dlIMG" src="../../assets/img/downloadApp.png" alt="" /> -->
    </div>
    <!-- PC 表格列头 -->
    <div v-if="isPcView" class="pc-table-header">
      <div class="pc-th pc-th--title">标题</div>
      <div class="pc-th pc-th--author">发帖人</div>
      <div class="pc-th pc-th--date">最后更新</div>
      <div class="pc-th pc-th--stats">回复/浏览</div>
      <div class="pc-th pc-th--action"></div>
    </div>

    <van-pull-refresh
      class="van-pull-refresh"
      style="min-height: 100vh;"
      v-model="refreshing"
      @refresh="onRefresh"
      :disabled="pullRefreshDisabled"
    >
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <template v-for="(item, index) in list">
          <item :item="item" :type="1" :key="index"></item>
        </template>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {
  plateList,
  plateSearch,
  getSubPostIds,
  subscribe,
  cancelSubscribe,
  wxuser,
  yichenLoginEx,
} from '@/api/base';
import swiperComponents from '../components/swiper.vue';
import item from '../components/item';
import { getTimeShow } from '@/utils/index';
import { isPcClient } from '@/views/PC/utils';
export default {
  name: 'plateList',
  components: {
    item,
    swiperComponents,
  },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      sortTime: false,
      checkboxShow: false,
      pcDropdownShow: false,
      checkboxGroup: [
        { title: '只看成交', type: 4 },
        { title: '只看求购', type: 1 },
        { title: '只看出售', type: 2 },
      ],
      page: {
        rows: 10,
        current: 1,
        scrollid: null,
      },
      list: [],
      searchType: 'title',
      searchInfo: null,
      searchContent: null,
      subPostIds: [],
      type: [],
      types: [],
      isVip: false,
      isSearch: false,
      pullRefreshDisabled: false,
      adData: this.$store.state.app.adBanner.smallList,
      // 记录当前页面内 banner 是否展示
      showBanner: true,
    };
  },
  computed: {
    isPcView() {
      return isPcClient();
    },
    stickyStyle() {
      return {
        position: 'sticky',
        top: isPcClient() ? '0px' : '-78px',
        zIndex: 99,
        background: '#fff',
      };
    },
    // isVip() {
    //   return !this.$store.state.app.userinfos.isVip == 0;
    // },
  },
  created() {
    this.init();
    document.addEventListener('gesturestart', function(event) {
      event.preventDefault();
    });
  },
  activated() {
    if (this.$route.query.id != this.searchInfo.id) {
      this.init(true);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('click', this.closePcDropdown);
  },
  methods: {
    getTimeShow,
    handleCloseBanner() {
      this.showBanner = false;
    },
    handleFilterClick() {
      if (this.isPcView) {
        this.pcDropdownShow = !this.pcDropdownShow;
      } else {
        this.checkboxShow = true;
      }
    },
    pcDropdownToggle(type) {
      const idx = this.types.indexOf(type);
      if (idx > -1) {
        this.types.splice(idx, 1);
      } else {
        this.types.push(type);
      }
    },
    closePcDropdown(e) {
      if (
        this.pcDropdownShow &&
        this.$refs.filterTrigger &&
        !this.$refs.filterTrigger.contains(e.target)
      ) {
        this.pcDropdownShow = false;
      }
    },
    back() {
      window.history.back();
    },
    handleDownloadApp() {
      window.location.href = 'https://h5.yichenbao.cn/#/pagesB/dowloadApp/index';
    },
    init(status) {
      window.scrollTo(0, 0);
      console.log(this.$route.query);
      this.searchContent = null;
      if (this.$route.query.searchContent) {
        this.searchContent = this.$route.query.searchContent;
      }
      getSubPostIds({ openId: window.openId }).then(res => {
        this.subPostIds = res.data;
      });
      this.searchInfo = this.$route.query;
      console.log(this.$route.query);
      if (status) {
        //
        this.list = [];
        this.finished = false;
        this.page = { rows: 10, current: 1, scrollid: null };
        if (this.isPcView) {
          // 阻止 van-list 在 loading=false 时同时触发 @load，避免双重请求导致 page.current 错乱
          this.loading = true;
        }
        this.onLoad();
      }

      if (
        this.$store.state.app.userinfos.isVip == 1 &&
        this.$store.state.app.userinfos.vipExpireTime
      ) {
        this.isVip = true;
      } else {
        this.isVip = false;
      }
    },
    async onLoad() {
      // this.$toast.loading({
      //   duration: 0, // 持续展示 toast
      //   forbidClick: true,
      //   message: '...',
      // });
      let filter = {
        sectionCode: this.$route.query.code,
        field: this.searchType,
        types: this.type.length > 0 ? this.type : null,
      };
      let query = {
        indexname: 'post',
        keyWords: this.searchContent,
        ...this.page,
        sort: this.sortTime ? 'lastupdatetime' : 'disp', //disp
      };
      await plateList({
        filter: filter,
        query: query,
        // searchContent: this.searchContent,
      }).then(res => {
        res.data.data.map(item => {
          return (item.subscribe = this.subPostIds.indexOf(item.id) != -1 ? true : false);
        });
        let tmpList = res.data.data;
        let list = this.list || [];
        if (this.refreshing) {
          list = tmpList;
          this.refreshing = false;
        } else if (tmpList.length) {
          list = [...list, ...tmpList];
        } else {
          this.finished = true;
        }

        this.loading = false;

        this.list = list;
        this.page.scrollid = res.data.scrollid;
        this.page.current++;
        // this.$toast.clear();
      });
    },
    onSearch() {
      if (
        this.$store.state.app.userinfos.isVip == 1 &&
        this.$store.state.app.userinfos.vipExpireTime
      ) {
        let searchType;
        switch (this.searchType) {
          case 'title':
            searchType = '1';
            break;
          case 'author':
            searchType = '2';
            break;
          case 'content':
            searchType = '3';
            break;
          default:
            break;
        }
        plateSearch({
          sectionCode: this.$route.query.code,
          searchType: searchType,
          searchContent: this.searchContent,
        }).then(res => {
          // this.list = res.data.records;
          // this.loading = false;
          // this.onLoad();
          this.refreshing = false;
          this.list = [];
          this.page = { rows: 10, current: 1, scrollid: null };
          this.finished = false;

          this.onLoad();
        });
      } else {
        this.$dialog
          .confirm({
            title: '暂未开通会员',
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
          })
          .then(() => {
            // on confirm
            this.$router.push({ path: '/vip', query: { item: new Date().getTime() } });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    toggle() {
      this.refreshing = false;
      this.list = [];
      this.finished = false;
      this.page = { rows: 10, current: 1, scrollid: null };
      if (this.isPcView) {
        window.scrollTo(0, 0);
        // 阻止 van-list 在 loading=false 时同时触发 @load，避免双重请求导致 page.current 错乱
        this.loading = true;
      }
      this.onLoad();
    },
    selType() {
      if (!this.isVip) {
        this.type = [];
        this.$dialog
          .confirm({
            title: '暂未开通会员',
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
          })
          .then(() => {
            // on confirm
            this.$router.push({ path: '/vip', query: { item: new Date().getTime() } });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        let arr = [];
        this.types.map(item => {
          arr.push(item);
          if (item == 2) {
            arr.push(0);
          }
        });
        this.type = arr;
        this.toggle();
      }
      this.checkboxShow = false;
      this.pcDropdownShow = false;
    },
    checkboxGroupToggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    getTypeName() {
      if (this.type.length == 0 || this.type.length == 4) {
        return '全部帖子';
      } else {
        let str = '';
        this.type.map((item, index) => {
          if (item == 4) {
            str += '成交';
          }
          if (item == 1) {
            str += '求购';
          }
          if (item == 2) {
            str += '出售';
          }
          if (index == 0) {
            str += '/';
          }
        });
        return str;
      }
    },
    showOpenVip() {
      if (!this.isVip) {
        this.$dialog
          .confirm({
            title: '暂未开通会员',
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
          })
          .then(() => {
            // on confirm
            this.$router.push({ path: '/vip', query: { item: new Date().getTime() } });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    listsortTime(e) {
      console.log(e);
      if (!this.isVip) {
        this.sortTime = false;
        this.$dialog
          .confirm({
            title: '暂未开通会员',
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
          })
          .then(() => {
            // on confirm
            this.$router.push({ path: '/vip', query: { item: new Date().getTime() } });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.onRefresh();
      }
    },
    onRefresh(refreshing = true) {
      this.list = [];
      this.refreshing = refreshing;
      this.finished = false;
      this.page = { rows: 10, current: 1, scrollid: null };
      document.documentElement.scrollTop = 0;
      window.pageYOffset = 0;
      document.body.scrollTop = 0;
      if (this.isPcView) {
        this.loading = true;
      }
      this.onLoad();
    },
    goBack(item) {
      window.location.href = `${item.lasturl}`;
    },
    setSubscribe(item) {
      subscribe({ postId: item.id }).then(res => {
        this.$toast('关注成功');
        item.subscribe = true;
      });
    },
    cancelSubscribe(item) {
      this.$dialog
        .confirm({
          title: '',
          message: '是否取消关注',
        })
        .then(() => {
          // on confirm
          cancelSubscribe({ postId: item.id }).then(res => {
            this.$toast('已取消关注');
            item.subscribe = false;
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    handleScroll() {
      let scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;

      //变量windowHeight是可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //你想做的事情
        console.log('header  你已经到底部了');
      }
      if (scrollStep < 0) {
        console.log('header 滚动条向上滚动了！');
      } else {
        console.log('header  滚动条向下滚动了！');
        this.pullRefreshDisabled = true;
      }
      // 判断是否到了最顶部
      if (scrollTop <= 0) {
        this.pullRefreshDisabled = false;
        console.log('header 到了最顶部');
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('click', this.closePcDropdown);
  },
};
</script>
<style lang="less" scoped>
.bannerWrap {
  position: relative;
  overflow: hidden;
}
.bannerClose {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  font-size: 12px;
}
.titleRow {
  display: flex;
  font-size: 14px;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  box-sizing: border-box;
  background: linear-gradient(0deg, #fff1eb 0%, #ace0f9 100%);
  .plateIcon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
}
.titleRow__main {
  display: flex;
  align-items: center;
  min-width: 0;
}

.titleRow__link {
  color: #2a82e4;
  text-decoration-line: underline;
}

.titleRow__sep {
  margin: 0 4px;
}

.titleRow__meta {
  flex-shrink: 0;
}
.searchTypeClass:first-child {
  margin-left: 10px;
}
.searchTypeClass {
  margin-top: 10px;
  /* margin-left: px; */
  font-size: 13px;
  justify-content: space-around;
}

.searchBox__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
}
.itemBox {
  background: #fff;
  margin-top: 10px;
  padding: 10px;
}
.itemBox .title {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 16px;
  padding-right: 40px;
}
.itemBox .follow {
  position: absolute;
  display: block;
  right: 0px;
  top: -10px;
  padding: 10px;
}
.itemBox .custom-title {
  margin-left: 10px;
  white-space: nowrap; /* 规定文本是否折行 */
  overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
  text-overflow: ellipsis;
  font-size: 13px;
  color: #383838;
}
.itemBox .desc {
  margin-top: 5px;
  display: flex;
  color: #969799;
  font-size: 13px;
  justify-content: space-around;
}
.itemBox .desc:first-child {
  margin-top: 10px;
}
.desc .custom-titl {
  flex: 1;
  white-space: nowrap; /* 规定文本是否折行 */
  overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
  text-overflow: ellipsis;
}
.van-pull-refresh {
  /* height: calc(100vh - 100px) !important;
  overflow: auto !important; */
}

.searchBox {
  padding-top: 4px;
  box-sizing: border-box;
  background: #e5e5e5;
  border: 0.3px solid #e5e5e5;
  padding-bottom: 9px;
  .van-search {
    background: #fff;
    font-size: 20px;
    padding: 3px 0;
    border: 1px solid #e5e5e5;
    box-shadow: 0px 0px 25.5px #f2f5e9;
    border-radius: 5px;

    .van-search__content {
      background: transparent;
    }
  }
  .searchbtn {
    width: 65px;
    font-size: 16px;
    height: 30px;
    opacity: 1;
    border-radius: 8px;
    background: linear-gradient(
      45deg,
      #ff8177 0%,
      #ff867a 0%,
      #ff8c7f 21%,
      #f99185 52%,
      #cf556c 78%,
      #b12a5b 100%
    );
    text-align: center;
    line-height: 30px;
    color: #fff;
  }
}

.searchBox__type {
  flex: 1;
  margin-top: 8px;
  position: relative;
  font-size: 13px;
  text-align: right;
}

.pc-filter-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 100;
  min-width: 160px;
  padding: 6px 0;
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  text-align: left;
}

.pc-filter-dropdown__item {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: #f5f7fa;
  }
}

.pc-filter-dropdown__check {
  display: inline-block;
  width: 20px;
  font-size: 14px;
  color: #1989fa;
  flex-shrink: 0;
}

.pc-filter-dropdown__footer {
  padding: 6px 12px 4px;
  border-top: 1px solid #f0f0f0;
  margin-top: 4px;
}

.pc-filter-dropdown__btn {
  width: 100%;
  padding: 6px 0;
  font-size: 13px;
  color: #fff;
  background: #1989fa;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: #1278e0;
  }
}

.downLoadApp {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  font-size: 14px;
  background: #c55168;
  color: #fff;
  .dlIMG {
    display: block;
    width: 18px;
    height: 18px;
    margin-left: 10px;
  }
}
</style>
<style lang="less">
/* ── PC 表格列头 ────────────────────────────────────────── */
.pc-table-header {
  display: none;
}

body.pc-mode .pc-table-header {
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 36px;
  background: linear-gradient(0deg, rgba(255, 241, 235, 0.6) 0%, rgba(172, 224, 249, 0.6) 100%);
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid rgba(20, 58, 93, 0.1);
  margin-top: 8px;
}

body.pc-mode .pc-th {
  font-size: 12px;
  font-weight: 600;
  color: #70859b;
  white-space: nowrap;
  user-select: none;
}

body.pc-mode .pc-th--title {
  flex: 1;
  min-width: 0;
  padding-left: 4px;
  padding-right: 12px;
}
body.pc-mode .pc-th--author {
  width: 100px;
  flex-shrink: 0;
}
body.pc-mode .pc-th--date {
  width: 120px;
  flex-shrink: 0;
}
body.pc-mode .pc-th--stats {
  width: 90px;
  flex-shrink: 0;
}
body.pc-mode .pc-th--action {
  width: 28px;
  flex-shrink: 0;
}

/* ── 列表容器圆角底部 ───────────────────────────────────── */
body.pc-mode .plate-list-page .van-pull-refresh {
  min-height: auto !important;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 0 0 12px 12px;
  border: 1px solid rgba(20, 58, 93, 0.08);
  border-top: none;
  overflow: hidden;
}

body.pc-mode .plate-list-page .van-list__finished-text {
  font-size: 12px;
  color: #9db0c3;
  padding: 14px 0;
}

/* ── 顶部筛选区 ──────────────────────────────────────────── */
body.pc-mode .plate-list-page .plate-list-page__sticky {
  top: 0px !important;
  margin-bottom: 0;
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.95) !important;
  box-shadow: 0 2px 12px rgba(17, 49, 79, 0.06);
  border: 1px solid rgba(20, 58, 93, 0.07);
  margin-bottom: 4px;
}

body.pc-mode .plate-list-page .bannerWrap {
  max-height: 120px;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
}

body.pc-mode .plate-list-page .titleRow {
  margin-bottom: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: linear-gradient(0deg, rgba(255, 241, 235, 0.7) 0%, rgba(172, 224, 249, 0.7) 100%);
}

body.pc-mode .plate-list-page .titleRow .plateIcon {
  width: 18px;
  height: 18px;
}

body.pc-mode .plate-list-page .titleRow .custom-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a3853;
}

body.pc-mode .plate-list-page .searchBox {
  padding: 0;
  background: transparent;
  border: none;
}

body.pc-mode .plate-list-page .searchBox .van-search {
  padding: 0;
  border: 1px solid rgba(20, 58, 93, 0.1);
  border-radius: 8px;
  box-shadow: none;
  background: #fff;
}

body.pc-mode .plate-list-page .searchBox__toolbar {
  justify-content: flex-start;
  flex-wrap: nowrap;
  gap: 0 16px;
  margin-top: 8px;
}

body.pc-mode .plate-list-page .searchTypeClass {
  margin-top: 0;
  font-size: 13px;
}

body.pc-mode .plate-list-page .searchBox__type {
  margin-top: 0;
  font-size: 13px;
  color: #4e6780;
  flex: none;
  margin-left: auto;
}

body.pc-mode .plate-list-page .downLoadApp {
  margin: 8px 0 0;
  padding: 6px 12px;
  border-radius: 8px;
  background: linear-gradient(135deg, #194b7d 0%, #2d7b6a 100%);
  font-size: 13px;
  min-height: auto;
}

body.pc-mode .pc-filter-dropdown {
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}
</style>
<style>
.radiaodiy .van-radio__icon {
  background: #fff;
  border-radius: 50%;
}
.searchTypeClass .van-checkbox__icon {
  background: #fff;
}
</style>
